// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AxBG","colMin":"styles_colMin__1c_L8"};